// localStorage can throw (private mode, blocked storage, SSR/tests). Never let it break the app.

export function readStorage(key) {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStorage(key, value) {
  try {
    if (value === null || value === undefined) globalThis.localStorage?.removeItem(key);
    else globalThis.localStorage?.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export const TENANT_KEY = "pharos.tenantId";
export const LOCALE_KEY = "pharos.locale";

export const getStoredTenantId = () => readStorage(TENANT_KEY);
export const setStoredTenantId = (id) => writeStorage(TENANT_KEY, id);
